import { Button, Illustration, Layout, TheVoice } from "@obs/base";
import { Error500Illustration } from "@obs/icons";
import { useIntl } from "react-intl";

export const UnexpectedError = () => {
	const { formatMessage } = useIntl();

	return (
		<Layout.Container maxWidth="sm">
			<Illustration illustration={Error500Illustration} />
			<TheVoice>
				{formatMessage({
					id: "trip_tracking.error.voice",
					defaultMessage: "Something went wrong",
				})}
			</TheVoice>
			<Layout.Box.Default>
				<Button.Primary onClick={() => window.location.reload()}>
					{formatMessage({
						id: "trip_tracking.error.paragraph",
						defaultMessage: "Try again",
					})}
				</Button.Primary>
			</Layout.Box.Default>
		</Layout.Container>
	);
};
